export const Name = 'request-favorites';
export const RequestFavorites = Name;

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- Used only to request state update across SPAs.
//# sourceMappingURL=index.js.map